// useBlocker.ts
import { useEffect } from 'react';
import {
  useLocation,
  useNavigate,
} from 'react-router';

export function useBlocker(shouldBlock: boolean, onConfirm: () => boolean) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!shouldBlock) return;

    // オリジナルのpushStateとreplaceStateを保存
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const originalPushState = window.history.pushState.bind(window.history);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const originalReplaceState = window.history.replaceState.bind(window.history);

    // pushStateをオーバーライド
    window.history.pushState = (...args) => {
      if (onConfirm()) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        originalPushState(...args);
      }
    };

    // replaceStateをオーバーライド
    window.history.replaceState = (...args) => {
      if (onConfirm()) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        originalReplaceState(...args);
      }
    };

    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (!onConfirm()) {
        e.preventDefault();
        e.returnValue = '';
      }
    };

    const handlePopState = () => {
      if (!onConfirm()) {
        void navigate(location.pathname, { replace: true });
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handlePopState);
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      window.history.pushState = originalPushState;
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      window.history.replaceState = originalReplaceState;
    };
  }, [shouldBlock, onConfirm, location.pathname, navigate]);
}
